<div class="success-indicator">
  <span class="check-circle">
    <i class="fa fa-check" aria-hidden="true"></i>
  </span>
  <p>{{labelKey | i18next}}</p>
</div>
